import React, { useState } from 'react';
import { Box, Card } from '@mui/material';
import { DialogForm, IDialogActions } from '../../../shared/components';
import { useTheme } from '@mui/material/styles';
import { TestDataIntegration } from './TestDataIntegration';


interface ITestDataIntegrationViewDialogProps {
    data: any;
    parentId?: string;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: true) => void;
}

export const TestDataIntegrationViewDialog: React.FC<ITestDataIntegrationViewDialogProps> = ({ data, parentId, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted }) => {

    const [loading, setLoading] = useState(false);

    const theme = useTheme();

    const actions: IDialogActions[] = [
        { id: 'close', text: 'Close', icon: 'cancel_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];
    return (
        <React.Fragment>
            <DialogForm
                title='TEST DATA INTEGRATION LIST VIEW'
                icon='offline_pin_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'xl'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Card sx={{ bgcolor: theme.palette.background.default, p: 1, width: '100%' }}>
                        <Box sx={{ display: 'flex', width: '100%', overflow: 'hidden', overflowY: 'auto' }}>
                            <TestDataIntegration
                                data={data}
                                testScenarioId={parentId}
                            />
                        </Box>
                    </Card>
                </React.Fragment>
            </DialogForm>
        </React.Fragment>
    );
};